import api from '../../../services/api';

const URL = '/organization';

class OrganizationService {
    getOrganization() {
        return api.get(URL);
    }

    /**
     * Owner-only. Schedules the organization for deletion (30-day grace period)
     * and cancels billing immediately. Requires the current password and the
     * exact organization name typed as confirmation.
     * @param {{ password: string, confirm_name: string }} data
     */
    deleteOrganization(data) {
        return api.delete(URL, { data });
    }

    /**
     * Owner-only. Cancels a pending scheduled deletion.
     */
    restoreOrganization() {
        return api.post(`${URL}/restore`);
    }
}

export default new OrganizationService();

